export function formatTime24Hour(timeStr) {
  // timeStr example: "6:18 PM,Wednesday"
  if (!timeStr) return "";

  const [timePart] = timeStr.split(","); // "6:18 PM"
  const [time, modifier] = timePart.trim().split(" "); // ["6:18", "PM"]

  let [hours, minutes] = time.split(":").map(Number);

  if (modifier.toUpperCase() === "PM" && hours !== 12) {
    hours += 12;
  } else if (modifier.toUpperCase() === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}
